// routes
export const routeAfterAuthenticated = '/dashboard';
export const routeLogin = '/login';

// session
export const SESSION_NAME = 'OnTheBuckSession';
